import { getProductTokens } from '@sirius-cybernetics-42/product-config'

import { ChainId, Token } from '../../sdk'

function toProductToken(chainId: ChainId, symbol: string) {
  const product = getProductTokens(chainId).find((entry) => entry.symbol === symbol)
  if (!product) {
    throw new Error(`Missing product token ${symbol} for chain ${chainId}`)
  }
  return product
}

/**
 * Infinite Creative — constantes de referencia (tests, LP watch).
 * Direcciones desde `@sirius-cybernetics-42/product-config`.
 */
const ctoastProduct = toProductToken(ChainId.INFINITE_CREATIVE, 'CTOAST')
const cdontProduct = toProductToken(ChainId.INFINITE_CREATIVE, 'C-DONT')

export const CTOAST = new Token(
  ChainId.INFINITE_CREATIVE,
  ctoastProduct.address,
  ctoastProduct.decimals,
  ctoastProduct.symbol,
  ctoastProduct.name,
)

export const CDONT = new Token(
  ChainId.INFINITE_CREATIVE,
  cdontProduct.address,
  cdontProduct.decimals,
  cdontProduct.symbol,
  cdontProduct.name,
)
